// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1CSZS","infoBtn":"quickbooks_infoBtn__3rAaX","formBox":"quickbooks_formBox__198ie","formFooter":"quickbooks_formFooter__2YUdk"};